import { toast } from "react-toastify";
import { TagAPI } from "../constants/apiRoutes";
import { tagActions } from "../reducers/tag";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewTag = (data, navigate) => {
  return async (dispatch) => {
    dispatch(tagActions.actionStart());
    try {
      await apiService.post(TagAPI.create(), data);
      dispatch(tagActions.actionSuccess("create"));

    } catch (err) {
      dispatch(tagActions.clearError());
      handleError(err);
    }
  };
};

export const updateTag = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(tagActions.actionStart());
    return apiService
      .put(TagAPI.update(id), data)
      .then((response) => {
        // toast.success("Uspešno ste izmenili tag", {
        //   theme: "colored",
        // });
        // navigate("/tag-list");
        dispatch(tagActions.actionSuccess("update"));
        
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteTag = (id) => {
  return (dispatch) => {
    return apiService
      .delete(TagAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali tag", {
          theme: "colored",
        });

        dispatch(fetchTagList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchTagList = () => {
  return (dispatch) => {
    return apiService
      .get(TagAPI.list())
      .then((response) => {
        dispatch(tagActions.fetchTagList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchTagFormList = () => {
  return (dispatch) => {
    dispatch(tagActions.actionStart());
    return apiService
      .get(TagAPI.form())
      .then((response) => {
        dispatch(tagActions.fetchTagFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchTagById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(TagAPI.getById(id))
      .then((response) => {
        dispatch(tagActions.fetchTagDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
